import React from 'react'

function WebFeaturebox1() {
    return (
        <div className='homebox2main' id='feature-box1'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/img-engage2.webp" alt="hero-img" />
                    </div>
                    <div className='homebox2-right'>
                        <span>Web Stamper</span>
                        <h2>Digitize Your Loyalty Experience</h2>
                        <p>Transform traditional loyalty programs into a fast and seamless digital experience with an advanced web stamper system. Easily reward customers with digital stamps, track progress instantly, and encourage repeat visits through a modern and engaging platform.</p>
                        <h5>Powerful Features for Business Growth</h5>
                        <ul>
                            <li>Add and manage digital stamps instantly through the web platform</li>
                            <li>Track customer rewards and loyalty progress in real time</li>
                            <li>Reduce manual processes with a fast and automated stamping system</li>
                            <li>Increase repeat visits with a simple and engaging reward experience</li>
                            <li>Access customer activity insights to improve retention and engagement</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WebFeaturebox1